import { app } from '../../../../../app';

app.service('ImportSharedPasswordsModal', modal);

/** @ngInject */
function modal($uibModal) {
    return () => $uibModal.open({
        component: 'companySharingCenterSharedPasswordsImport',
        resolve: {passwordManagers},
    }).result
}

/** @ngInject */
function passwordManagers($filter, PasswordManagers) {
    return PasswordManagers.list()
       // .then((items) => $filter('filter')(items, {ssoEnabled: true}))
        .then((items) => $filter('orderBy')(items, 'publicService.serviceName'));
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/import/import-shared-password.modal.js